import type { ContentObjectList, NonEventContentObjectDetail } from 'models';
import { canSeeContentObjectLikes } from 'permissions';
import { LikeCount } from '../../../like-count';
import { StatusBarLayout } from '../status-bar-layout';

type P = {
  item: ContentObjectList | NonEventContentObjectDetail;
};

const GroupStatusBar = ({ item }: P) => {
  const { liked: isLiked, likesCount } = item;

  const isLikeCountVisible = likesCount > 0 && canSeeContentObjectLikes({ contentObject: item });

  return isLikeCountVisible ? (
    <StatusBarLayout left={<LikeCount count={likesCount} liked={isLiked} />} right={null} />
  ) : null;
};

export default GroupStatusBar;
